import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Download, Trash2 } from "lucide-react";
import { toast } from "sonner";
import MotoSignupsView from "@/pages/admin/MotoSignupsView";

function List({ endpoint, columns, empty }) {
  const [rows, setRows] = useState([]);
  const load = () => api.get(`/${endpoint}`).then((r) => setRows(r.data)).catch(() => {});
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [endpoint]);
  const remove = async (id) => { if (!window.confirm("Eliminare?")) return; await api.delete(`/${endpoint}/${id}`); load(); };
  return (
    <div className="space-y-2">
      {rows.map((r) => (
        <div key={r.id} className="bg-white rounded-lg border border-brass/15 p-4" data-testid={`${endpoint}-item-${r.id}`}>
          <div className="flex justify-between items-start gap-3">
            <div className="text-sm space-y-0.5 min-w-0">
              {columns.map((c) => {
                const val = c.format ? c.format(r[c.key], r) : r[c.key];
                return val ? <p key={c.key} className="text-oak/80"><span className="text-oak/50">{c.label}: </span>{String(val)}</p> : null;
              })}
            </div>
            <Button size="icon" variant="ghost" onClick={() => remove(r.id)}><Trash2 className="w-4 h-4 text-bordeaux" /></Button>
          </div>
        </div>
      ))}
      {rows.length === 0 && <p className="text-oak/50 text-sm py-6 text-center">{empty}</p>}
    </div>
  );
}

const PRANZO_LABELS = { si: "Sì", no: "No", nse: "Non lo so ancora" }; // eslint-disable-line no-unused-vars

export default function RequestsView() {
  const download = async (path, filename) => {
    try {
      const res = await api.get(path, { responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a"); a.href = url; a.download = filename; a.click();
      URL.revokeObjectURL(url);
    } catch (e) { toast.error("Esportazione fallita"); }
  };
  return (
    <div>
      <Tabs defaultValue="group">
        <TabsList className="bg-cream-dark mb-4 flex-wrap h-auto">
          <TabsTrigger value="group" data-testid="req-tab-group">Gruppi & Eventi</TabsTrigger>
          <TabsTrigger value="moto" data-testid="req-tab-moto">Motoraduno</TabsTrigger>
          <TabsTrigger value="resv" data-testid="req-tab-resv">Prenotazioni</TabsTrigger>
          <TabsTrigger value="contacts" data-testid="req-tab-contacts">Contatti marketing</TabsTrigger>
        </TabsList>
        <TabsContent value="group">
          <List endpoint="group-requests" empty="Nessuna richiesta." columns={[
            { key: "nome", label: "Nome" }, { key: "azienda", label: "Azienda" }, { key: "telefono", label: "Tel" },
            { key: "email", label: "Email" }, { key: "data_desiderata", label: "Data" }, { key: "persone", label: "Persone" },
            { key: "pasto", label: "Pasto" }, { key: "tipo_evento", label: "Tipo" }, { key: "note", label: "Note" }, { key: "created_at", label: "Ricevuta" },
          ]} />
        </TabsContent>
        <TabsContent value="moto">
          <MotoSignupsView />
        </TabsContent>
        <TabsContent value="resv">
          <List endpoint="reservations" empty="Nessuna prenotazione." columns={[
            { key: "nome", label: "Nome" }, { key: "telefono", label: "Tel" }, { key: "data", label: "Data" },
            { key: "ora", label: "Ora" }, { key: "persone", label: "Persone" }, { key: "note", label: "Note" }, { key: "created_at", label: "Ricevuta" },
          ]} />
        </TabsContent>
        <TabsContent value="contacts">
          <div className="flex justify-end mb-3">
            <Button onClick={() => download("/contacts/export", "contatti_masetti.csv")} className="bg-brass hover:bg-brass-hover text-oak-dark" data-testid="export-csv"><Download className="w-4 h-4 mr-2" />Esporta CSV</Button>
          </div>
          <List endpoint="contacts" empty="Nessun contatto." columns={[
            { key: "nome", label: "Nome" }, { key: "email", label: "Email" }, { key: "telefono", label: "Tel" },
            { key: "consent_date", label: "Consenso" }, { key: "source", label: "Fonte" }, { key: "revoked", label: "Revocato" },
          ]} />
        </TabsContent>
      </Tabs>
    </div>
  );
}
